import { reduxKey } from './constants';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getCurrentAdSafety = (state)=>getState(state).currentSafety;
export const getDeviationSafety = (state)=>getState(state).deviationSafety;
export const getQueuedDeviationId = (state)=>getState(state).queuedDeviationId;
